import { match } from 'ts-pattern';
import { Pill, type PillProps, type PillVariant } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import { ExcDtccUtcV1Side } from '@interxfi/types/generated/api';

interface UtcTradeSidePillProps extends Omit<PillProps, 'children' | 'variant'> {
  side: ExcDtccUtcV1Side | undefined;
}

export function UtcTradeSidePill({ isPending, loadingCharacters = 4, side, ...props }: UtcTradeSidePillProps) {
  return (
    <Pill
      isPending={!side || isPending}
      loadingCharacters={loadingCharacters}
      {...props}
      variant={match(side)
        .returnType<PillVariant>()
        .with(ExcDtccUtcV1Side.Buy, () => 'green')
        .with(ExcDtccUtcV1Side.Sell, () => 'danger')
        .otherwise(() => 'neutral')}
    >
      <TranslatedText defaultValue={side} i18nKey={{ namespace: 'excDtccUtcV1', enumName: 'ExcDtccUtcV1Side', value: side }} />
    </Pill>
  );
}
